import { useNavigate, useLocation } from 'react-router-dom';

export const useNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const getBackNavigation = (): (() => void) => {
        // Logique intelligente de retour basée sur l'historique
        // et le contexte de la page
        return () => navigate(-1);
    };
    
    const navigateBack = () => {
        navigate(-1);
    };
    
    return { 
        getBackNavigation, 
        navigateBack,
        navigate,
        location 
    };
};
